import api from '../../../utils/api';

const route = '/fa_questions';

export const getFaqLandingApi = (params) => api.get(route, { params });
